import withStyles from "isomorphic-style-loader/withStyles";
import React from "react";
import styles from "../../styles.scss";
import { Button, ButtonGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
} from "@fortawesome/free-solid-svg-icons";

interface ActiveButtons {
  textAlignment: string;
  textFormat?: string;
}

interface MessageButtonControlProps {
  activeButtons: ActiveButtons;
  handleTextAlignmentClick: (value: string) => void;
  handleTextFormatClick?: (value: string) => void;
  showFormatControls?: boolean;
}

const MessageButtonControls = ({
  activeButtons,
  handleTextAlignmentClick,
  handleTextFormatClick,
  showFormatControls = false,
}: MessageButtonControlProps) => {
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      {showFormatControls && (
        <>
          <ButtonGroup className="btn-group no-hover">
            <Button
              onClick={() => handleTextFormatClick("none")}
              style={{
                backgroundColor:
                  activeButtons.textFormat === "none" ? "#E2E8F0" : "#fff",
              }}
              className={styles.controlButton}
              size="sm"
            >
              Aa
            </Button>
            <Button
              onClick={() => handleTextFormatClick("uppercase")}
              style={{
                backgroundColor:
                  activeButtons.textFormat === "uppercase" ? "#E2E8F0" : "#fff",
              }}
              className={styles.controlButton}
              size="sm"
            >
              AA
            </Button>
          </ButtonGroup>
          <div
            style={{
              width: "1px",
              height: "32px",
              backgroundColor: "#E2E8F0",
              margin: "0 8px",
            }}
          />
        </>
      )}

      {/* Alignment Buttons */}
      <ButtonGroup className="btn-group no-hover">
        <Button
          onClick={() => handleTextAlignmentClick("start")}
          style={{
            backgroundColor:
              activeButtons.textAlignment === "start" ? "#E2E8F0" : "#fff",
          }}
          className={styles.controlButton}
          size="sm"
        >
          <FontAwesomeIcon icon={faAlignLeft} />
        </Button>
        <Button
          onClick={() => handleTextAlignmentClick("center")}
          style={{
            backgroundColor:
              activeButtons.textAlignment === "center" ? "#E2E8F0" : "#fff",
          }}
          className={styles.controlButton}
          size="sm"
        >
          <FontAwesomeIcon icon={faAlignCenter} />
        </Button>
        <Button
          onClick={() => handleTextAlignmentClick("end")}
          style={{
            backgroundColor:
              activeButtons.textAlignment === "end" ? "#E2E8F0" : "#fff",
          }}
          className={styles.controlButton}
          size="sm"
        >
          <FontAwesomeIcon icon={faAlignRight} />
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default withStyles(styles)(MessageButtonControls);
